import React from "react";
import { businessMatchingOwnedBusinessEntityTalkRoomsPath } from "../../../../../routes";
import { SharedCurrentUser } from "../../lib/types";
import SmsIcon from "../icons/SmsIcon";

import { Box } from "../ui/chakra";
import { HStack, Link, Show, Stack, Text } from "@chakra-ui/react";

const hoverStyle = { backgroundColor: "#EDF5F3" };

const MessagesButton = ({
  currentUser,
}: {
  currentUser: SharedCurrentUser | undefined;
}) => {
  const owned_business_entity_has_talk_room = currentUser?.is_approved
    ? currentUser.owned_business_entity_has_talk_room
    : null;

  if (owned_business_entity_has_talk_room == null) return null;

  const ContentsForButton = () => {
    return (
      <>
        <Show above="xl">
          <HStack gap={1}>
            <SmsIcon />
            <Text fontSize="sm">メッセージ</Text>
          </HStack>
        </Show>
        <Show below="xl">
          <Stack gap={0} alignItems="center">
            <HStack h={7}>
              <SmsIcon boxSize={6} />
            </HStack>
            <Box fontSize="xs">受発注</Box>
          </Stack>
        </Show>
      </>
    );
  };

  return (
    <Link
      px={4}
      href={businessMatchingOwnedBusinessEntityTalkRoomsPath(
        owned_business_entity_has_talk_room.code,
      )}
      textDecoration="none"
      color="inherit"
      _hover={hoverStyle}
      h="full"
      placeContent="center"
      target="_blank"
      rel="noreferrer"
    >
      <ContentsForButton />
    </Link>
  );
};

export default MessagesButton;
